import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'
import { useEffect } from 'react'

import { useLazyGetPreSignedUrlQuery } from './formUpload.api'

const useFormAttachmentsUpload = () => {
  const [submitAttachments, { data, isFetching, isError, error }] =
    useLazyGetPreSignedUrlQuery()

  useEffect(() => {
    if (isError) {
      handleMutationError(error, 'failed to upload files!')
    }
  }, [isError])
  return { data, isFetching, submitAttachments }
}

export default useFormAttachmentsUpload
